import React from "react";
import { Route } from "react-router-dom";

import { AdminTemplateDashboard } from "../adminDashboards/adminRecurringTaskJobStatsDashboard/AdminTemplateDashboard";
import SuperAdminDashboard from "../superAdmin/Dashboard/SuperAdminDashboard";
import PathfinderEntry from "../superAdmin/Pathfinder/PathfinderEntry";
import WorkflowEditor from "../superAdmin/WorkflowEditor/WorkflowEditor";
import RoleEditor from "../superAdmin/RoleEditor/RoleEditor";
import SuperAdminBluePrints from "../superAdmin/RoleEditor/SuperAdminBluePrints";
import Plans from "../superAdmin/Plans/Plans";
import PlanFeatures from "../superAdmin/PlanFeatures/PlanFeatures";
import BillingDetails from "../Payment/BillingPage/BillingDetails";
import OrganizationWorkspace from "../superAdmin/OrganizationWorkspace/OrganizationWorkspace";
import VisibilityMetricsDashboard from "../superAdmin/VisibilityMetrics/VisibilityMetricsDashboard";

export const SuperAdminRoutesMap = (
  <React.Fragment>
    <Route path="/superadmin/plans" element={<Plans />} />
    <Route path="/superadmin/plan-feature/:planId" element={<PlanFeatures />} />
    <Route path="/superadmin/projections" element={<AdminTemplateDashboard />} />
    <Route path="/dashboard/superadmin" element={<PathfinderEntry />} />
    <Route path="/superadmin/management" element={<SuperAdminDashboard />} />
    <Route path="/superadmin/visibility-metrics" element={<VisibilityMetricsDashboard />} />
    <Route path="/superadmin/organizations/:organizationId" element={<OrganizationWorkspace />} />
    <Route path="/superadmin/workflow/:orgId" element={<WorkflowEditor />} />
    <Route path="/superadmin/roles/:orgId" element={<RoleEditor />} />
    <Route path="/superadmin/blueprints" element={<SuperAdminBluePrints />} />
    <Route path="/dashboard/superadmin/*" element={<PathfinderEntry />} />
    <Route path="/dashboard/superadmin/billing-details/:orgId" element={<BillingDetails />} />
  </React.Fragment>
);
